import safeJSONParse from '@/utils/safeJSONParse'

const removeLastChar = str => str.slice(0, str.length - 1)
const bracesOpenCloseMap = {
  '{': '}',
  '[': ']'
}
const addMissingBraces = (string, stack) => {
  while (stack.length !== 0) {
    string += bracesOpenCloseMap[stack.pop()]
  }
  return string
}

/**
 * this trims useless characters from beginning and end of the JSON. e.g, it can remove backs-ticks(code-block) from json.
 * @param str
 * @returns {*|string}
 */
const extractJSONFromString = str => {
  let startIndex = -1,
    endIndex = -1,
    startPointer = 0,
    endPointer = str.length - 1
  while (startPointer < endPointer && (startIndex === -1 || endIndex === -1)) {
    if (startIndex === -1) {
      if (['{', '['].includes(str[startPointer])) {
        startIndex = startPointer
      }
      startPointer++
    }
    if (endIndex === -1) {
      if ([']', '}'].includes(str[endPointer])) {
        endIndex = endPointer
      }
      endPointer--
    }
  }
  const json = str.substring(startIndex, endIndex + 1)
  return json
}

export function completeJSON(jsonString) {
  jsonString = jsonString
    .trim()
    .replace(/(.*),(\s*])/g, '$1]') // replace comma(,) before ] e.g [{title: 'A'},] => [{title: 'A'}]
    .replace(/(.*),(\s*})/g, '$1}') // replace comma(,) before } e.g [{title: 'A',}] => [{title: 'A'}]
  let lastBraceIndex = -1
  let lastColonIndex = -1
  let isInString = false
  let isInEscape = false
  let isAfterColon = false
  let isInsideKey = false
  let stack = []
  let commaIndex = -1

  const extractedJSONString = extractJSONFromString(jsonString)
  if (safeJSONParse(extractedJSONString, true)) return extractedJSONString

  for (let i = 0; i < jsonString.length; i++) {
    const char = jsonString.charAt(i)

    if (char === '\\') {
      // If the current character starts an escape sequence, mark it
      isInEscape = true
    } else if (isInEscape) {
      // If the current character is part of an escape sequence, skip it
      isInEscape = false
    } else if (char === '"') {
      // If the current character is a quotation mark, toggle the string flag
      isInString = !isInString
      if (!isInString) {
        isInsideKey = false
      } else if (
        (stack[stack.length - 1] === '{' && lastColonIndex < lastBraceIndex) ||
        !isAfterColon
      ) {
        isInsideKey = true
      }
    } else if (!isInString) {
      if (char === '{' || char === '[') {
        // If the current character is the start of an object or array, push it onto the stack
        stack.push(char)
        lastBraceIndex = i
      } else if (char === '}' || char === ']') {
        // If the current character is the end of an object or array, pop the stack
        stack.pop()
      } else if (char === ':') {
        // If the current character is a colon, mark that we are after a colon
        isAfterColon = true
        lastColonIndex = i
      } else if (char === ',') {
        commaIndex = i
        // If the current character is a comma and we are after a colon, reset the flag
        if (isAfterColon) {
          isAfterColon = false
        }
      }
    }
  }

  const braces = Object.entries(bracesOpenCloseMap).flat()

  if (!isInString && braces.includes(jsonString[jsonString.length - 1])) {
    while (stack.length !== 0) {
      jsonString += bracesOpenCloseMap[stack.pop()]
    }
    return jsonString
  }

  if (!isInString && jsonString.endsWith(',')) {
    jsonString = removeLastChar(jsonString)
  } else if (isAfterColon && !jsonString.endsWith(':') && isInString && !isInsideKey) {
    jsonString += '"'
  } else if (!jsonString.endsWith('"') || lastColonIndex < lastBraceIndex || isInsideKey) {
    jsonString = jsonString.slice(0, Math.max(commaIndex, lastBraceIndex + 1))
  }
  jsonString = addMissingBraces(jsonString, stack)
  jsonString = extractJSONFromString(jsonString)
  return jsonString
}
